import apiRequest from "../../helpers/apiRequest";

export default async () => {
    const res = await apiRequest({
        method: 'get',
        url: `accounts/dj-rest-auth/user/`,
    });
    return res.data
}
